import { Component, Input, OnInit } from '@angular/core';
import { MenuController } from '@ionic/angular';
import { CashierContentService } from 'src/app/services/cashier/cashier-content.service';
import { CashierService } from 'src/app/services/cashier/cashier.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { MenuStateService } from 'src/app/services/menu-state/menu-state.service';
import { ResponsibleGamingService } from 'src/app/services/responsible-gaming-service/responsible-gaming.service';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { Navigator } from '../../menu/navigator';

declare var window: any;

@Component({
  selector: 'app-deposit-button',
  templateUrl: './deposit-button.component.html',
  styleUrls: ['./deposit-button.component.scss'],
})
export class DepositButtonComponent implements OnInit {
  @Input() size;
  @Input() type;
  @Input() buttonText;
  @Input() campaignId;
  @Input() depositMethod;
  @Input() navigateBackPage;

  public recievedSelectedBonus;
  public showButton = false;

  public defaultDepositPage: string;
  public pageToRedirect: string;
  public isAuthenticated:boolean = false;
  public environmentName: string;

  defaultIsTrue = item => item.is_default == true;

  constructor(
    public cashierService: CashierService,
    public cashierContentService: CashierContentService,
    public menuCtrl: MenuController,
    public navigator: Navigator,
    public utilsService: UtilsService,
    public userSession: UserSessionService,
    public config: ConfigService,
    public menuStateService: MenuStateService,
    public responsibleGamingProvider: ResponsibleGamingService,
  ){}

  ngOnInit() {
    let siteDepositButton = this.config.getConfig().SITE_DEPOSTI_BTN;
    this.environmentName = this.config.getState().toLowerCase();
    this.defaultDepositPage = "DepositMainComponent";
    this.showButton = (!siteDepositButton) ? false : true;
    this.userSession.isAuthenticated().then(res => {
      if(res){
        this.isAuthenticated = true;
      }
    });
  }

  onDeposit() {


    this.responsibleGamingProvider.getAllPendingLimit().subscribe(
      (response: any) => {
        if (response.payload.length !== 0) {
          this.navigator.navigateTo('LimitConfirmationComponent', { forceModal: true },{ callBackFn: () => { this.navigator.navigateTo("DepositMainComponent"); }});
        } else {
          this.navigator.navigateTo("DepositMainComponent");
          console.log('No Pending Limit for User')
        }
      },
      (error) => {
        this.navigator.navigateTo("DepositMainComponent");
        console.log('Error:  Pending Limit')
      }
    );
    // this.navigator.navigateTo("DepositMainComponent");

    // this.cashierService.getActiveTypesCategories({ include_types: false }).subscribe((response: any) => {
    //   if (response) {
    //     let data = response.payload.filter(this.defaultIsTrue);
    //     const lastDeposit = data.length > 0 ? data[0].code : null;
    //     const getPage = this.depositMethod ?? lastDeposit;
    //     this.pageToRedirect = this.cashierContentService.getVendorPage(getPage);
    //     window._window_has_closed = true;
    //     if (!!this.pageToRedirect) this.redirect();
    //     return;
    //   }
    //   this.pageToRedirect = this.defaultDepositPage;
    //   return this.redirect();
    // }, (e) => { window._window_has_closed = true;});
  }

  redirect() {
        this.utilsService.setCampaignId(this.campaignId);

        let navParams: any = {};

        if (!!this.depositMethod) navParams.depositMethod = this.depositMethod;
        if (!!this.navigateBackPage) {
          navParams.navigateBackPage = this.navigateBackPage;
        } 
        else if(this.type === 'sidemenu' || this.type === 'navbar-text' || this.type === 'navbar') {
          navParams.navigateBackPage = this.type
        }
        else {
          navParams.navigateBackPage = "default";
        }

        this.recievedSelectedBonus = this.cashierContentService.getSelectedBonus();
        if (!!this.campaignId) {
          this.cashierContentService.setSelectBestOne(false)
          navParams.bonusCode = this.campaignId;
        } else {
          if (this.recievedSelectedBonus) {
            this.cashierContentService.setSelectBestOne(true);
            navParams.bonusCode = this.recievedSelectedBonus.offer.campaign_code;
          }
        }
        this.navigator.navigateTo(this.pageToRedirect, { multipleModals: true }, navParams);
        if (this.recievedSelectedBonus) {
          this.cashierContentService.setSelectedBonus(this.recievedSelectedBonus);
        }
      }

      //Temprorary for Development
      onDeposits() {
        return this.navigator.navigateTo("DepositPaywithmybankComponent");
      }

}
